import { render, staticRenderFns } from "./MirrorsRedirectorsContainer.vue?vue&type=template&id=51ed9b31&"
import script from "./MirrorsRedirectorsContainer.vue?vue&type=script&lang=js&"
export * from "./MirrorsRedirectorsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports